import React from "react";
import {
  HashRouter as Router,
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import Configuration from "./components/Configuration";
import AiPlanner from "./components/AiPlanner";
import Imprint from "./components/Imprint";
import Privacy from "./components/Privacy";
import Footer from "./components/common/Footer";
import Example from "./components/Example";
import FullscreenTimer from "./components/FullscreenTimer";
import LinkNotice from "./components/common/LinkNotice";
import { normalizeSearch } from "./helper/linkNormalizer";
import { LanguageProvider, useLanguage } from "./i18n/LanguageContext";

// The full-page timer view is meant to occupy the entire display on its
// own, so it skips the footer nav that every other route gets.
function AppShell() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const { language } = useLanguage();
  const isFullscreenPage = location.pathname === "/fullscreen";

  // Links opened from outside the app (often written by an AI assistant)
  // may use the short plan/start format. Rewrite them into the canonical
  // parameters before any page reads them. In-app navigations (PUSH and
  // REPLACE) are left alone, so a card field that is briefly empty while
  // being edited is never "corrected" under the user's fingers.
  if (navigationType === "POP") {
    const normalized = normalizeSearch(location.search, undefined, language);
    if (normalized !== null) {
      return (
        <Navigate
          replace
          to={{ pathname: location.pathname, search: normalized.search }}
          state={{ linkWarnings: normalized.warnings }}
        />
      );
    }
  }

  return (
    <div className="app-shell">
      <LinkNotice />
      <div className="app-content">
        <Routes>
          <Route path="/" element={<Configuration />} />
          <Route path="/ai" element={<AiPlanner />} />
          <Route path="/examples" element={<Example />} />
          <Route path="/imprint" element={<Imprint />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/fullscreen" element={<FullscreenTimer />} />
        </Routes>
      </div>
      {!isFullscreenPage && <Footer />}
    </div>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <Router>
        <AppShell />
      </Router>
    </LanguageProvider>
  );
}
